module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-2"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.family_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][1]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.family_name),
      expression: "input.family_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Yamada"
    },
    domProps: {
      "value": (_vm.input.family_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.family_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.family_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.family_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][1]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.given_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][2]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.given_name),
      expression: "input.given_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Taro"
    },
    domProps: {
      "value": (_vm.input.given_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.given_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.given_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.given_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][2]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.address_1.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][3]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.address_1),
      expression: "input.address_1"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "301"
    },
    domProps: {
      "value": (_vm.input.address_1)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.address_1.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.address_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_vm._v("AAA\n          "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.address_1,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][3]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][4]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.address_2),
      expression: "input.address_2"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "3-3-3"
    },
    domProps: {
      "value": (_vm.input.address_2)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.address_2.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.address_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.city.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][5]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.city),
      expression: "input.city"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Kobe"
    },
    domProps: {
      "value": (_vm.input.city)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.city.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.city,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][4]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.prefecture.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][6]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.prefecture),
      expression: "input.prefecture"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Hyogo"
    },
    domProps: {
      "value": (_vm.input.prefecture)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.prefecture.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.prefecture = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.prefecture,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][5]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.zip_code.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][7]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.zip_code),
      expression: "input.zip_code"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "6520043"
    },
    domProps: {
      "value": (_vm.input.zip_code)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.zip_code.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.zip_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.zip_code,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][6]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.country_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][8]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.country_name),
      expression: "input.country_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Japan"
    },
    domProps: {
      "value": (_vm.input.country_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.country_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.country_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.country_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][8]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.phone_nunber.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][9]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.phone_nunber),
      expression: "input.phone_nunber"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "08012345678"
    },
    domProps: {
      "value": (_vm.input.phone_nunber)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.phone_nunber.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.phone_nunber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.phone_nunber,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][9]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.email.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][10]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.email),
      expression: "input.email"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "abc@abc.com"
    },
    domProps: {
      "value": (_vm.input.email)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.email.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.email,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][11]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.email,
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][12]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][11]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.password),
      expression: "input.password"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.input.password)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.password.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][13]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][14]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "minLength"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_2'][15]"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_2'][12]"
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-666a8303!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/MyPage/OrdererInfo/PageForm.vue
// module id = 710
// module chunks = 0